import { graphql } from "@opensea/graphql"
import { currencyIdentifierFragment } from "../currencies/utils"

export const UsdPriceFragment = graphql(
  `
    fragment UsdPrice on Price {
      usd
      token {
        contractAddress
        unit
        ...currencyIdentifier
      }
    }
  `,
  [currencyIdentifierFragment],
)
